module.exports = __webpack_public_path__ + "static/media/1005986.8775d192.png";